import Rollbar from 'rollbar';

import getEnv, { Environment } from '@/utils/environment';

const env = getEnv();

export const rollbarConfig: Rollbar.Configuration = {
  accessToken: process.env.NEXT_PUBLIC_ROLLBAR_TOKEN, // POST_CLIENT_ITEM_ACCESS_TOKEN comes from PXE-shared-workflows
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: env !== Environment.LOCAL,
  payload: {
    environment: env,
    client: {
      javascript: {
        guess_uncaught_frames: true,
        source_map_enabled: true,
        code_version: process.env.NEXT_PUBLIC_GIT_HASH,
      },
    },
  },
};
